<template>
<svg viewBox="0 0 24 24" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-fill-repost`]" width="1em" height="1em" v-bind="$attrs"><path d="M10.2506 3.82706C10.2506 2.56339 11.7175 1.86599 12.6975 2.66372L21.2713 9.64242C22.1316 10.3428 22.1316 11.6566 21.2712 12.3569L12.6975 19.3354C11.7174 20.1331 10.2506 19.4357 10.2506 18.172V14.8783C9.42249 14.8844 8.48863 15.0424 7.54 15.5014C6.32779 16.088 5.03761 17.187 3.89448 19.1901C3.6047 19.6979 3.05144 19.8269 2.63017 19.7178C2.20078 19.6067 1.76396 19.2047 1.80325 18.5883C2.08651 14.1447 3.48858 11.3202 5.31489 9.56267C6.89467 8.04237 8.72734 7.38485 10.2506 7.11822V3.82706Z"/></svg>
</template>
<script>

export default {
  name: 'IconFillRepost',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
